import React from "react";
import { useIntl } from "react-intl";
import { ContentTextInputCard } from "crossdock/common/flow/cards/ContentTextInputCard";
import { useFcDimsAndWeightScanProductBarcode } from "crossdock/modes/inspection/fc-dims-and-weight/cards/ScanProductBarcodeCard/useFcDimsAndWeightScanProductBarcode";
import { DIMS_AND_WEIGHT_LABELS } from "crossdock/modes/inspection/labels";

export const FcDimsAndWeightScanProductBarcodeCard: React.FC = () => {
  const { onProductBarcodeChange, submitProductBarcode, barcode, loading, errorMessage } =
    useFcDimsAndWeightScanProductBarcode();
  const { formatMessage } = useIntl();

  return (
    <ContentTextInputCard
      onSubmit={submitProductBarcode}
      title={formatMessage(DIMS_AND_WEIGHT_LABELS.scanProductBarcodeCardTitle)}
      onChange={onProductBarcodeChange}
      value={barcode}
      disabled={loading}
      errorMessage={errorMessage}
      placeholder={formatMessage(DIMS_AND_WEIGHT_LABELS.productBarcode)}
      icon="scan"
      accentColor="BLUE"
    />
  );
};
